<template>
	<div
		v-if="isOpen"
		:class="[
			'fixed left-0 top-0 h-dvh w-screen z-30 flex flex-col justify-center',
			isPopup
				? 'bg-white/20 backdrop-blur-sm'
				: 'bg-white/90 backdrop-blur-xl backdrop-brightness-90',
		]"
	>
		<div
			v-if="!isPopup"
			class="z-10"
		>
			<div
				:class="[
					'container flex justify-between items-center py-6',
					isSmall ? 'max-w-5xl' : '',
				]"
			>
				<LazyAtomLogoFysio
					v-if="!dialogs.hideLogo.value && layer === LayerEnum.Fysio"
					class="h-14"
					dark
				/>
				<LazyAtomLogoFit
					v-if="!dialogs.hideLogo.value && layer === LayerEnum.Fit"
					class="h-14"
					dark
				/>
				<LazyAtomLogoHier
					v-if="!dialogs.hideLogo.value && layer === LayerEnum.Werk"
					class="h-14"
					dark
				/>
				<button
					v-if="isClosable && !dialogs.hideRegularCloseButton.value"
					@click="close"
				>
					<span class="sr-only">Sluiten</span>
					<LazyAtomFontAwesome
						icon="fa-xmark"
						class="w-8 h-8"
					/>
				</button>
			</div>
		</div>
		<button
			v-else-if="isClosable"
			class="absolute top-0 right-0 bottom-0 left-0"
			title="Sluiten"
			@click="close"
		/>
		<div
			v-show="isContentOpen"
			id="molecule-dialog-scrollable-container"
			class="relative overflow-auto overflow-x-clip hide-scrollbars container"
			:class="{
				'max-w-5xl': isSmall,
				'bg-white rounded shadow-2xl w-[95%] my-8 px-12': isPopup,
			}"
		>
			<div
				v-if="isClosable && isPopup"
				class="flex justify-end pt-8"
			>
				<button
					title="Sluiten"
					@click="close"
				>
					<LazyAtomFontAwesome
						icon="fa-xmark"
						class="w-8 h-8 text-gray-400"
					/>
				</button>
			</div>
			<slot />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { LayerEnum } from '#base/core/enums/LayerEnum';

const {
	isOpen = false,
	isSmall = false,
	isPopup = false,
	isClosable = true,
} = defineProps<{
	isOpen?: boolean;
	isSmall?: boolean;
	isPopup?: boolean;
	isClosable?: boolean;
}>();

const dialogs = useDialogs();

const isContentOpen = ref(true);

const {
	public: {
		layer,
	},
} = useRuntimeConfig();

watch(
	() => isOpen,
	(isOpen) => {
		if (isOpen) {
			// Opening on query didn't open content, so content is now open by default
			// it's closed and then reopened for the animation when manually opened.
			isContentOpen.value = false;
			setTimeout(() => {
				isContentOpen.value = true;
			}, 150);
		}
	}
);

const emit = defineEmits(['close']);
const close = () => {
	isContentOpen.value = false;
	setTimeout(() => {
		emit('close');
	}, 100);
};
</script>
